/* eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }] */
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import ReactSelect from 'components/StyledSelect/react_select';
import reactSelectStyles from 'components/ReactSelect/styles';

const ProductTypeSelect = ({ className, ...props }) =>
  <ReactSelect
    resetValue={[]}
    name="produt_type"
    className={cx(reactSelectStyles, className)}
    label="Product Type"
    placeholder="STK or SOS"
    options={[{ value: 'SOS', label: 'SOS' }, { value: 'STK', label: 'STK' }]}
    {...props}
  />;

ProductTypeSelect.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

export default ProductTypeSelect;



// WEBPACK FOOTER //
// ./client/app/shared/components/formElements/ProductTypeSelect/index.jsx